<template>
    <div v-loading="loading" class="rebateList">
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="日期：">
                    <el-date-picker 
                        style="width:120px;"
                        @change="search"
                        format="YYYY-MM"
                        value-format="YYYYMM"
                        v-model="formInline.month"
                        type="month"
                        placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="Payers：">
                    <el-select v-model="formInline.payerId" clearable filterable style="width:120px" @change="search" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in payersList"
                            :key="index"
                            :label="item.name+'('+item.payer_id+')'"
                            :value="item.payer_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-button @click="download()" type="primary" icon="Download">下载</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table">
            <el-table :height="'calc('+(tableHeight)+'px)'" stripe :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%">
                <el-table-column label="PayerName">
                    <template #default="scope">
                        {{scope.row.payer}}
                    </template>
                </el-table-column>
                <el-table-column label="LinkId">
                    <template #default="scope">
                        {{scope.row.linkId}}
                    </template>
                </el-table-column>
                <el-table-column label="InvoiceID">
                    <template #default="scope">
                        {{scope.row.invoice_id}}
                    </template>
                </el-table-column>
                <el-table-column label="供应商">
                    <template #default="scope">
                        {{ scope.row.entity }}
                    </template>
                </el-table-column>
                <el-table-column label="VAP返点">
                    <template #default="scope">
                        {{ (Number(scope.row.discount1)*100).toFixed(0)+'%' }}
                    </template>
                </el-table-column>
                <el-table-column label="税率">6%</el-table-column>
                <el-table-column label="月份">
                    {{this.formInline.month.toString().substring(0,4)+'-'+this.formInline.month.toString().substring(4,6)}}
                </el-table-column>
                <el-table-column label="金额" align="right">
                    <template #default="scope">
                        {{ Number(scope.row.cost).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="" align="right" width="20">
                </el-table-column>
            </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination";
    import {getRebateList,downloadRebate,getPayerList} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    export default {
        components:{
            Pagination
        },
        name:'rebateList',
        data() {
            return {
                loading:false,
                loadingPage:false,
                tableHeight:500,
                formInline:{
                    month:'',
                    payerId:'',
                    region:'cn',
                    page: 1,
                    limit: 20,
                },
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                tableData:[],
                selected:[],
                payersList:[],
            }
        },
        
        created() {
            this.getPayersList();
            let date = new Date();
            //获取当前年份的后一年
            let endY =date.getFullYear();
            //获取当前月
            let endM = (date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1 ) : date.getMonth()+1);
            this.formInline.month=endY+endM;
            if(localStorage.getItem('rebateListForm')){
                this.formInline = JSON.parse(localStorage.getItem('rebateListForm'))
            }
            this.getData();
        },
        methods:{
            //获取列表
            getData() {
                this.loadingPage = true;
                getRebateList(this.formInline).then(res => {
                    this.loadingPage = false
                    if(res.code ==2000) {
                        this.tableData = res.data
                        this.pageparm.page = res.page;
                        this.pageparm.limit = res.limit;
                        this.pageparm.total = res.total;
                    }
                })
            },
            
            // 获取payer列表
            getPayersList(){
                getPayerList({name:'',payer_id:'',region:'cn',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.payersList = res.data.data;
                    }else{
                        this.$message.error('获取Payer列表失败！');
                    }
                })
            }, 
            // 通过地址下载
            download(){
                this.loading = true;
                downloadRebate(this.formInline).then(res=>{
                    this.loading = false;
                    if(res.code==2000){
                        if(res.data){
                            this.downloadFile(res.data)
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            // 下载
            downloadFile(url){
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.href = url
                a.click()
                setTimeout(()=>{
                    a.remove()
                },1000)
            },
           
            search() {
                this.formInline.page = 1
                this.formInline.limit = 20
                localStorage.setItem('rebateListForm',JSON.stringify(this.formInline))
                this.getData()
            },

            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
                this.tableHeight =  getTableHeight(tabSelectHeight)
            },
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },

        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
